import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class PaymentProvider extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static PaymentProviderProperties: (
    | {
        property: keyof PaymentProvider;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof PaymentProvider;
        type: 'alias';
      }
    | {
        property: keyof PaymentProvider;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'name', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    PaymentProvider.PaymentProviderProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        PaymentProvider.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        PaymentProvider.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        PaymentProvider.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(PaymentProviderObject: Partial<PaymentProvider>) {
    super();

    PaymentProvider.PaymentProviderProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = PaymentProviderObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  name?: 'AuthorizeNet' | 'Payabli' | 'Stripe';
  createdAt?: Date;
  updatedAt?: Date;
}
